// src/hooks/usePositions.js
import { useQuery } from '@tanstack/react-query';
import { fetchPositionsData } from '../utils/multicall';

export const usePositions = () => {
    const query = useQuery({
        queryKey: ['positions'],
        queryFn: async () => {
            const configResponse = await fetch('/config.json');
            if (!configResponse.ok) {
                throw new Error('Failed to fetch config.json');
            }
            const config = await configResponse.json();
            return fetchPositionsData(config.positions || []);
        },
        staleTime: 60000,
        retry: 2,
        placeholderData: [],
    });
    return {
        ...query,
        refetch: query.refetch,
    };
};